import {
  FETCH_NOTIFICATIONS_REQUEST,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAILURE,
  FETCH_NOTIFICATION_REQUEST,
  FETCH_NOTIFICATION_SUCCESS,
  FETCH_NOTIFICATION_FAILURE,
  UPDATE_NOTIFICATIONS_REQUEST,
  UPDATE_NOTIFICATIONS_FAILURE,
  UPDATE_NOTIFICATIONS_SUCCESS,
  DELETE_NOTIFICATIONS_REQUEST,
  DELETE_NOTIFICATIONS_FAILURE,
  DELETE_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_RELEASE_REQUEST,
  FETCH_NOTIFICATIONS_RELEASE_SUCCESS,
  FETCH_NOTIFICATIONS_RELEASE_FAILURE,
  CLEAR_NOTIFICATION_ERRORS,    // Nouvelles imports
  CLEAR_NOTIFICATION_SUCCESS,
} from './actionTypes';

const initialState = {
  notifications: [],
  notificationsRelease: [],
  notification: null,
  loadingNotif: false,
  errorNotif: null,
  editItemId: null,
  notificationAdded: null
};

const Notifications = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        loadingNotif: true,
        errorNotif: null,
        notificationAdded: false
      };
    case FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loadingNotif: false,
        notifications: action.payload.data,
      };
    case FETCH_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        loadingNotif: false,
        errorNotif: action.payload,
      };
    case FETCH_NOTIFICATIONS_RELEASE_REQUEST:
      return {
        ...state,
        loadingNotif: true,
        errorNotif: null,
        notificationAdded: false
      };
    case FETCH_NOTIFICATIONS_RELEASE_SUCCESS:
      return {
        ...state,
        loadingNotif: false,
        notificationsRelease: action.payload.data,
      };
    case FETCH_NOTIFICATIONS_RELEASE_FAILURE:
      return {
        ...state,
        loadingNotif: false,
        errorNotif: action.payload,
      };
    case FETCH_NOTIFICATION_REQUEST:
      return {
        ...state,
        loadingNotif: true,
        errorNotif: null,
        notificationAdded: false
      };
    case FETCH_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loadingNotif: false,
        notification: action.payload.data,
      };
    case FETCH_NOTIFICATION_FAILURE:
      return {
        ...state,
        loadingNotif: false,
        errorNotif: action.payload,
      };
    case UPDATE_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        loadingNotif: true,
        errorNotif: null,
        notificationAdded: false
      };
    case UPDATE_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loadingNotif: false,
        notification: null,
        notificationAdded: true
      };
    case UPDATE_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        loadingNotif: false,
        errorNotif: action.payload,
      };
    case DELETE_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        loadingNotif: true,
        errorNotif: null,
        notificationAdded: false
      };
    case DELETE_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notificationAdded: true,
        loadingNotif: false,
        notifications: state.notifications.filter(notification => notification.id !== action.payload),
      };
    case DELETE_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        loadingNotif: false,
        errorNotif: action.payload,
      };
    case CLEAR_NOTIFICATION_ERRORS:
      return {
        ...state,
        errorNotif: null,
      };
    case CLEAR_NOTIFICATION_SUCCESS:
      return {
        ...state,
        notificationAdded: null,
      };
      
    default:
      return state;
  }
};

export default Notifications;